var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 28H16.0003C13.0548 28 10.667 25.6122 10.667 22.6667V9.33333C10.667 6.38781 13.0548 4 16.0003 4H24.0003C26.9458 4 29.3337 6.38781 29.3337 9.33333V18.6667M2.66699 9.33333H6.66699M16.0003 9.33333H24.0003M16.0003 14.6667H24.0003M16.0003 20H20.0003M21.3337 25.3333L23.6708 27.203C24.2279 27.6487 25.0373 27.5768 25.5071 27.0399L29.3337 22.6667M4.66699 28L5.60033 26.7556C6.29271 25.8324 6.66699 24.7095 6.66699 23.5556V6C6.66699 4.89543 5.77156 4 4.66699 4C3.56242 4 2.66699 4.89543 2.66699 6V23.5556C2.66699 24.7095 3.04127 25.8324 3.73366 26.7556L4.66699 28Z",
    stroke: "#101828",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon3);
export default __webpack_public_path__ + "static/media/galleryIcon3.122a17e538513e3f70704008fc6d2417.svg";
export { ForwardRef as ReactComponent };